export default function ({ store, redirect }) {
  const auth = store.state.auth;

  if (!auth.is_admin && helpers.isEmpty(auth.active_pt)) {
    return redirect('/panel');
  }
}
